import { InspectionStandardTypes } from './enums/InspectionStandardTypes';

export function isEemuaOrApi(inspectionStandardType?: InspectionStandardTypes | string) {
    if (
        inspectionStandardType === InspectionStandardTypes.Eemua159 ||
        inspectionStandardType === InspectionStandardTypes.Api653 ||
        inspectionStandardType === InspectionStandardTypes.Api570
    ) {
        return true;
    }
    return false;
}
